<template>
	<b-modal
		:visible="show"
		:hide-footer="true"
		@hide="close"
		:title="'modalTransactionsHistory.title' | translate"
	>
		<div v-if="loading" class="loader"><loader /></div>
		<div v-else-if="error" class="text-danger">{{ error }}</div>
		<ul class="list-unstyled" v-if="transactions">
			<li class="Transaction" v-for="txn in transactions" :key="txn.id">
				<div class="Row">
					<p class="Reason">
						{{
							`modalTransactionsHistory.type.${
								txn.amount > 0 ? 'deposit' : 'withdraw'
							}` | translate
						}}
					</p>
					<span
						class="Value"
						:class="txn.amount > 0 ? 'text-success' : 'text-danger'"
						>{{ txn.amount > 0 ? '+' : '' }}{{ txn.amount }} i$</span
					>
				</div>
				<p class="Date">{{ txn.modified | toDateTime }}</p>
				<p v-if="txn.reason" class="Description">{{ txn.reason }}</p>
			</li>
			<li class="Empty" v-if="transactions.length === 0">
				{{ 'modalTransactionsHistory.empty' | translate }}
			</li>
		</ul>
	</b-modal>
</template>

<script>
import Loader from '@/components/Loader'
export default {
	name: 'modal-transactions-history',
	components: {
		Loader,
	},
	data: () => ({
		loading: false,
		error: '',
		transactions: [],
	}),
	filters: {
		toDateTime(value) {
			if (!value) return '-'

			const format = v => v.toString().padStart(2, '0')

			const date = new Date(value.slice(0, -6))
			return `${format(date.getDate())}.${format(
				date.getMonth() + 1
			)}.${date.getFullYear()} / ${format(date.getHours())}:${format(
				date.getMinutes()
			)}:${format(date.getSeconds())}`
		},
	},
	props: ['show', 'id'],
	watch: {
		show() {
			this.error = ''
			this.loading = false
			this.transactions = []
			this.requestProfileData()
		},
	},
	created() {
		this.requestProfileData()
	},
	methods: {
		close() {
			this.$emit('close')
		},
		requestProfileData() {
			if (!this.id || !this.show) return

			this.error = ''
			this.loading = true
			this.axios({
				url: `indigo_dollars/balance/${this.id}`,
			})
				.then(({ data }) => {
					this.transactions = data.txns
					this.loading = false
				})
				.catch(e => {
					this.loading = false
					this.error = e
				})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:not(.close) {
	margin: 10px;
}

.loader svg {
	display: block;
	margin: auto;
	width: 100px;
	height: 100px;
}

.Transaction {
	padding-top: 16px;
	padding-bottom: 16px;
	border-bottom: 1px solid #ddd;
}

.Transaction:last-child {
	padding-bottom: 0;
	border-bottom: none;
}

.Row {
	display: flex;
	justify-content: space-between;
	margin: 0 0 16px;
	align-items: center;
}

.Reason {
	font-size: 24px;
	font-weight: bold;
	margin: 0;
}
.Value {
	font-size: 22px;
	font-weight: bold;
	margin: 0;
}

.Date {
	font-style: italic;
	margin: 0 0 12px;
}
.Description {
	font-size: 14px;
	color: grey;
	margin: 0;
}
.Empty {
	font-size: 24px;
	font-weight: bold;
}
</style>
